import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { supabase } from '../client/client';
import { resumenPlano } from '../utils/texto';

const Busqueda = () => {
  const { term } = useParams();
  const [results, setResults] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchResults = async () => {
      setLoading(true);
      setError(null);

      if (!term || term.trim() === '') {
        setResults([]);
        setLoading(false);
        return;
      }

      // Escapamos comas y paréntesis que rompen la sintaxis de .or() en PostgREST
      const safeTerm = term.replace(/[,()]/g, ' ');
      const pattern = `%${safeTerm}%`;

      const [{ data: news, error: newsError }, { data: categories, error: categoriesError }] =
        await Promise.all([
          supabase
            .from('news')
            .select('*')
            .or(`title.ilike.${pattern},body.ilike.${pattern}`)
            .order('created_at', { ascending: false }),
          supabase.from('categorias').select('*'),
        ]);

      if (newsError) {
        console.error('Error fetching search results:', newsError);
        setError('No se pudieron cargar los resultados.');
        setLoading(false);
        return;
      }

      if (categoriesError) {
        console.error('Error fetching categories:', categoriesError);
      }

      setResults(news || []);
      setCategoriesData(categories || []);
      setLoading(false);
    };

    fetchResults();
  }, [term]);

  const getCategory = (categoryId) =>
    categoriesData.find((cat) => cat.id === categoryId);


  return (
    <div className="class_home">
      <div className="busqueda-header ed-shell">
        <h1 className="title">
          Resultados para: <em>{term}</em>
        </h1>
      </div>

      {loading && <p className="busqueda-status">Buscando…</p>}

      {!loading && error && <p className="busqueda-status">{error}</p>}

      {!loading && !error && results.length === 0 && (
        <p className="busqueda-status">
          No se encontraron noticias que coincidan con “{term}”.
        </p>
      )}

      {!loading && !error && results.length > 0 && (
        <div className="busqueda-lista">
          {results.map((item) => {
            const category = getCategory(item.category_id);
            return (
              <article key={item.id} className="busqueda-item">
                <Link to={`/noticias/${item.id}`}>
                  {item.image_url && (
                    <img src={item.image_url} alt={item.title} loading="lazy" decoding="async" />
                  )}
                </Link>
                <div>
                  {category && <p className="ed-kicker">{category.name}</p>}
                  <Link to={`/noticias/${item.id}`}>
                    <h2>{item.title}</h2>
                  </Link>
                  <p>{resumenPlano(item.body, 160)}</p>
                </div>
              </article>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Busqueda;
